module.exports = __webpack_public_path__ + "static/logo-d29aa464451fa382d5ebc77ad0da1d9e.svg";